/** 409 `code` values from POST /enroll when account step blocks completion (API message explains why). */
export const ENROLLMENT_ACCOUNT_CONFLICT_CODES = new Set([
  'account_already_exists',
  'enroll_wrong_password',
  'enroll_account_linked_other_business',
  'enroll_admin_not_eligible',
]);

export function isEnrollmentAccountConflict(error) {
  return Boolean(
    error?.status === 409 &&
      error?.code &&
      ENROLLMENT_ACCOUNT_CONFLICT_CODES.has(error.code),
  );
}

export function enrollmentAccountConflictTitle(code) {
  switch (code) {
    case 'enroll_wrong_password':
      return "Password doesn't match this account";
    case 'enroll_account_linked_other_business':
      return 'This email is already linked to a business';
    case 'enroll_admin_not_eligible':
      return 'This email cannot be used for provider signup';
    case 'account_already_exists':
    default:
      return 'Account already exists';
  }
}
